<!--
 * @Description: 根据tab限制内容
 * @Date: 2021-02-03 17:14:07
-->
<template>
  <div class="living-content">
    <!-- 评论,使用show防止组件内重新计时 -->
    <comment
      v-if="currentZdyMenu.type === 3"
      status="living"
      :qa-id="livingStore.detail.id"
      :type="5"
      :name="livingStore.detail.title"
      :detail="livingStore.detail"
      :hasSocket="true"
      :residenceTime="residenceTime"
      style="padding:.32rem"
    ></comment>
    <!-- 直播限制问卷 -->
    <survey
      v-else-if="currentZdyMenu.type === 2"
      :questionnaireId="currentZdyMenu.questionnaireId"
      :key="currentZdyMenu.questionnaireId"
    ></survey>
    <!-- 直播配置内容 -->
    <livingIntroduce v-else-if="currentZdyMenu.type === 1" />
    <div
      class="pre"
      style="padding:.32rem"
      v-else
      v-html="content || '无'"
    ></div>
  </div>
</template>

<script>
import comment from '@/components/Comment2';
import survey from '@/page/Survey';
import { selectByCourseMenuList } from '@/api/course.js';
import livingIntroduce from './livingIntroduce.vue';

export default {
  name: 'LivingContent',
  inject: ['livingStore'],
  components: {
    comment,
    survey,
    livingIntroduce
  },
  data() {
    return {
      content: '',
      residenceTime: 0,
      timer: null
    };
  },
  computed: {
    currentZdyMenu() {
      return this.livingStore.currentZdyMenu;
    }
  },
  watch: {
    currentZdyMenu: {
      async handler(v) {
        if (v.type === 1) {
          const { pdata } = await selectByCourseMenuList({ id: v.id });
          this.content = pdata.courseMen.content;
        }
      }
    }
  },
  methods: {
    signIn() {
      const detail = this.livingStore.detail;

      if (detail.isSignIn) {
        this.$vux.toast.show({
          type: 'text',
          text: '您已签到',
          position: 'middle'
        });
      }
      // else if (this.noQue) {
      //   this.$vux.toast.show({
      //     type: 'text',
      //     text: '当前课程还没有考题',
      //     position: 'middle',
      //     width: '6rem'
      //   });
      // }
      else {
        if (this.restTime >= 60) {
          this.$router.push({
            name: 'signIn',
            params: {
              id: detail.id
            },
            query: {
              isLiving: 1
            }
          });
        } else {
          this.$vux.toast.show({
            type: 'text',
            text: '听课满一分钟才能签到',
            position: 'middle',
            width: '6rem'
          });
        }
      }
    },
    stsign() {}
  },
  created() {
    this.timer = setInterval(() => {
      this.residenceTime += 1;
    }, 1000);
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  }
};
</script>

<style lang="scss">
.living-content {
  .pre {
    & > p {
      max-width: 100%;
      word-break: break-all;
    }
  }
}
</style>
